import React, { useState } from 'react';
import { Form,Card, Button, Modal, Alert, Row, Col } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';

const BookForm = () => {
  const [formData, setFormData] = useState({
    bookName: '',
    description: '',
    category: '',
    author: '',
    publication: '',
    inStock: ''
  });

  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    let formErrors = {};
    Object.keys(formData).forEach((field) => {
      if (!formData[field]) {
        formErrors[field] = `${field.replace(/([A-Z])/g, ' $1')} is required`;
      }
    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      setTimeout(() => {
        const isSuccess = Math.random() > 0.5;  
        if (isSuccess) {
          setShowSuccessModal(true);
        } else {
          setShowErrorModal(true);
        }
      }, 1000);
    }
  };

  return (
    <Card className="shadow-sm rounded-lg mx-auto p-4"style={{ maxWidth: '850px', width: '100%' }}>
   <div className="d-flex justify-content-center">
      <div style={{ maxWidth: '800px', width: '100%' }}>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="bookName">
            <Form.Label>Book Name</Form.Label>
            <Form.Control
              type="text"
              name="bookName"
              value={formData.bookName}
              onChange={handleInputChange}
              isInvalid={!!errors.bookName}
              placeholder="Enter book name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.bookName}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="description">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              name="description"
              rows={3}
              value={formData.description}
              onChange={handleInputChange}
              isInvalid={!!errors.description}
              placeholder="Enter description"
            />
            <Form.Control.Feedback type="invalid">
              {errors.description}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="category">
            <Form.Label>Category</Form.Label>
            <Row>
              <Col xs={11}>
                <Form.Control
                  as="select"
                  name="category"
                  value={formData.category}
                  onChange={handleInputChange}
                  isInvalid={!!errors.category}
                >
                  <option value="">Select Category</option>
                  <option value="Fiction">Fiction</option>
                  <option value="Non-fiction">Non-fiction</option>
                  <option value="Science">Science</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.category}
                </Form.Control.Feedback>
              </Col>
              <Col xs={1} className="d-flex align-items-center">
                <FaPlus style={{ cursor: 'pointer' }} />
              </Col>
            </Row>
          </Form.Group>

          <Form.Group controlId="author">
            <Form.Label>Author</Form.Label>
            <Row>
              <Col xs={11}>
                <Form.Control
                  as="select"
                  name="author"
                  value={formData.author}
                  onChange={handleInputChange}
                  isInvalid={!!errors.author}
                >
                  <option value="">Select Author</option>
                  <option value="Author 1">Author 1</option>
                  <option value="Author 2">Author 2</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.author}
                </Form.Control.Feedback>
              </Col>
              <Col xs={1} className="d-flex align-items-center">
                <FaPlus style={{ cursor: 'pointer' }} />
              </Col>
            </Row>
          </Form.Group>

          <Form.Group controlId="publication">
            <Form.Label>Publication</Form.Label>
            <Row>
              <Col xs={11}>
                <Form.Control
                  as="select"
                  name="publication"
                  value={formData.publication}
                  onChange={handleInputChange}
                  isInvalid={!!errors.publication}
                >
                  <option value="">Select Publication</option>
                  <option value="Publication 1">Publication 1</option>
                  <option value="Publication 2">Publication 2</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  {errors.publication}
                </Form.Control.Feedback>
              </Col>
              <Col xs={1} className="d-flex align-items-center">
                <FaPlus style={{ cursor: 'pointer' }} />
              </Col>
            </Row>
          </Form.Group>

          <Form.Group controlId="inStock">
            <Form.Label>In-Stock</Form.Label>
            <Form.Control
              type="number"
              name="inStock"
              value={formData.inStock}
              onChange={handleInputChange}
              isInvalid={!!errors.inStock}
              placeholder="Enter stock quantity"
            />
            <Form.Control.Feedback type="invalid">
              {errors.inStock}
            </Form.Control.Feedback>
          </Form.Group>

          <div className="d-flex justify-content-between mt-3">
            <Button variant="primary" type="submit">
              Submit
            </Button>
            <Button variant="secondary" type="button">
              Cancel
            </Button>
          </div>
        </Form>

        <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
          <Modal.Body>
            <Alert variant="success">Form submitted successfully!</Alert>
          </Modal.Body>
          <Button variant="secondary" onClick={() => setShowSuccessModal(false)}>
            Close
          </Button>
        </Modal>

        <Modal show={showErrorModal} onHide={() => setShowErrorModal(false)} centered>
          <Modal.Body>
            <Alert variant="danger">Failed to submit form. Please try again.</Alert>
          </Modal.Body>
          <Button variant="secondary" onClick={() => setShowErrorModal(false)}>
            Close
          </Button>
        </Modal>
      </div>
    </div>
    </Card>
 
  );
};

export default BookForm;
